import type { OpenAccountMutationMutation } from '../../../__generated__/graphql/api';

type Opening = NonNullable<OpenAccountMutationMutation['openAccount']>;

type OpeningToast = { tone: 'success' | 'info' | 'warning'; title: string; description?: string };

const applicantNumbers = (indices: number[]) => indices.map((index) => index + 1).join(' and ');

const TOAST_BY_STATUS = new Map<string, (opening: Opening) => OpeningToast>([
  [
    'boarded',
    ({ pendingCards, replayed }) =>
      pendingCards.length > 0
        ? {
            tone: 'warning',
            title: 'Account opened, a card is not issued yet',
            description: `Applicant ${applicantNumbers(pendingCards)} has no card yet. Submit this same form again to retry it.`,
          }
        : { tone: 'success', title: replayed ? 'Account already opened' : 'Account opened' },
  ],
  [
    'pending_review',
    ({ accountId }) => ({
      tone: 'info',
      title: 'Account held for KYC review',
      description: `Account ${accountId} boards once its applicants are approved.`,
    }),
  ],
]);

const REPLAY_NOTE = 'This same application was submitted before, so nothing new was opened.';

export const describeOpening = (opening: Opening): OpeningToast => {
  const toast = TOAST_BY_STATUS.get(opening.status)?.(opening) ?? {
    tone: 'info',
    title: `Account ${opening.status}`,
    description: `Account ${opening.accountId}.`,
  };

  return opening.replayed
    ? { ...toast, description: [REPLAY_NOTE, toast.description].filter(Boolean).join(' ') }
    : toast;
};
